import { render } from "./MySurveys.vue?vue&type=template&id=012dbfbc&scoped=true"
import script from "./MySurveys.vue?vue&type=script&lang=js"
export * from "./MySurveys.vue?vue&type=script&lang=js"

import "./MySurveys.vue?vue&type=style&index=0&id=012dbfbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012dbfbc"]])

export default __exports__